import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { Button, ModalWindow, ModalFullscreen } from '@cian/ui-kit';
import * as styles from './ModalConfirm.css';
import { Loader } from '../Loader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ModalConfirm(_ref) {
  var onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm,
    fullScreen = _ref.fullScreen,
    header = _ref.header,
    isVisible = _ref.isVisible,
    isLoading = _ref.isLoading,
    text = _ref.text,
    fixed = _ref.fixed,
    children = _ref.children,
    confirmButtonDisabled = _ref.confirmButtonDisabled,
    onOpen = _ref.onOpen;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isButtonLoading = _React$useState2[0],
    setIsButtonLoading = _React$useState2[1];
  React.useEffect(function () {
    if (onOpen) {
      onOpen();
    }
  }, [onOpen]);
  var handleConfirm = function handleConfirm() {
    setIsButtonLoading(true);
    onConfirm();
  };
  var content = /*#__PURE__*/_jsxs(React.Fragment, {
    children: [Boolean(text) && /*#__PURE__*/_jsx("div", {
      className: styles['text'],
      children: text
    }), children, isLoading && /*#__PURE__*/_jsx(Loader, {})]
  });
  var footer = /*#__PURE__*/_jsxs("div", {
    className: styles['footer'],
    children: [/*#__PURE__*/_jsx(Button, {
      theme: "fill_white_primary",
      size: "XS",
      onClick: onCancel,
      children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"
    }), /*#__PURE__*/_jsx(Button, {
      loading: isButtonLoading,
      disabled: confirmButtonDisabled || isLoading,
      size: "XS",
      onClick: handleConfirm,
      children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"
    })]
  });
  if (fullScreen) {
    return /*#__PURE__*/_jsx(ModalFullscreen, {
      onClose: onCancel,
      open: isVisible,
      theme: "white",
      children: /*#__PURE__*/_jsxs("div", {
        className: styles['wrapper'],
        children: [/*#__PURE__*/_jsx("div", {
          className: styles['header-wrapper'],
          children: header
        }), /*#__PURE__*/_jsx("div", {
          className: styles['content-wrapper'],
          children: content
        }), /*#__PURE__*/_jsx("div", {
          className: styles['footer-wrapper'],
          children: footer
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx(ModalWindow, {
    fixed: Boolean(fixed),
    header: header,
    content: content,
    footer: footer,
    size: "XS",
    width: 400,
    onClose: onCancel,
    open: isVisible
  });
}